// menuConfig.js
import HomeIcon from '@mui/icons-material/Home';
import GroupsIcon from '@mui/icons-material/Groups';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CategoryIcon from '@mui/icons-material/Category';
import Roles from './roles';

const menuItems = [
    {
        label: 'home',
        icon: <HomeIcon />,
        path: '/home',
        roles: [Roles.ADMIN],
    },
    {
        label: 'customers',
        icon: <DashboardIcon />,
        path: '/customers',
        roles: [Roles.ADMIN],
    },
    { type: 'divider' },
    {
        type: 'group',
        label: 'operations',
        icon: <EngineeringIcon />,
        roles: [Roles.ADMIN, Roles.USER],
        children: [
            {
                label: 'projects',
                path: '/projects',
                roles: [Roles.ADMIN],
            },
            {
                label: 'planner',
                path: '/planner',
                roles: [Roles.ADMIN, Roles.USER],
            },
            {
                label: 'timeTracking',
                path: '/time-tracking',
                roles: [Roles.ADMIN, Roles.USER],
            },
            {
                label: 'fieldReports',
                path: '/field',
                roles: [Roles.USER],
            },
        ],
    },
    {
        type: 'group',
        label: 'finance',
        icon: <AccountBalanceIcon />,
        roles: [Roles.ADMIN],
        children: [
            {
                label: 'quotes',
                path: '/quotes',
                roles: [Roles.ADMIN],
            },
            {
                label: 'contracts',
                path: '/contracts',
                roles: [Roles.ADMIN],
            },
            {
                label: 'invoices',
                path: '/invoices',
                roles: [Roles.ADMIN],
            },
            {
                label: 'reports',
                path: '/reports',
                roles: [Roles.ADMIN],
            },
        ],
    },
    {
        type: 'group',
        label: 'resources',
        icon: <CategoryIcon />,
        roles: [Roles.ADMIN],
        children: [
            {
                label: 'inventory',
                path: '/inventory',
                roles: [Roles.ADMIN],
                showStockBadge: true,
            },
            {
                label: 'services',
                path: '/services',
                roles: [Roles.ADMIN],
            },
        ],
    },
    {
        type: 'group',
        label: 'team',
        icon: <GroupsIcon />,
        roles: [Roles.ADMIN, Roles.USER],
        children: [
            {
                label: 'employees',
                path: '/employees',
                roles: [Roles.ADMIN],
            },
            {
                label: 'absences',
                path: '/absences',
                roles: [Roles.ADMIN, Roles.USER],
            },
            {
                label: 'publicHolidays',
                path: '/public-holidays',
                roles: [Roles.ADMIN],
            },
        ],
    },
];

export default menuItems;
